<template>
    <div class="campground__navigation">
      <CiButton class="navigation__button button--secondary" :disabled="status && status.loading" v-if="activeStep > 1" @click="prevStep">
          <iconArrowBlack class="icon icon--animated"></iconArrowBlack>
          <span>{{ $t('generic.buttons.stepBack') }}</span>
      </CiButton>
      <CiButton class="navigation__button button--primary" :disabled="!stepFulfilled || (status && status.loading)" @click="nextStep">
          <template v-if="status && !status.loading">
            <span>{{ $t('generic.buttons.nextStep') }}</span>
            <iconArrowWhite class="icon icon--animated"></iconArrowWhite>
          </template>
        <template v-if="status && status.loading">
          <span>{{ $t('generic.buttons.loading') }}</span>
          <span class="spinner"></span>
        </template>
      </CiButton>
    </div>
</template>
<script>
import { CiButton } from '@/components/index'
import iconArrowBlack from '@/assets/icons/arrow-black.svg'
import iconArrowWhite from '@/assets/icons/arrow-white.svg'

export default {
  name: 'CiProgressNavigation',
  components: { CiButton, iconArrowBlack, iconArrowWhite },
  props: {
    activeStep: {
      type: Number,
      required: true,
    },
    steps: {
      type: Object,
      required: true,
    },
    status: {
      type: Object,
      default: () => {},
      required: false,
    },
  },
  computed: {
    stepFulfilled() {
      return this.steps[this.activeStep].fulfilled
    },
  },
  methods: {
    prevStep() {
      this.$router.push({
        name: 'Step',
        params: { ...this.$route.params, step: this.activeStep - 1 },
      })
    },

    nextStep() {
      this.$router.push({
        name: 'Step',
        params: { ...this.$route.params, step: this.activeStep + 1 },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.campground__navigation {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 20px 0;

  @include media-breakpoint-up(md) {
    flex-direction: row;
    margin: 20px 0;
  }

  &.campground__navigation--inline {
    @include media-breakpoint-up(lg) {
      margin: 30px 0 40px;
    }
  }
}

.navigation__button {
  width: 100%;

  @include media-breakpoint-up(md) {
    width: auto;
  }

  &:last-child {
    margin-left: auto;
  }
}

.button--secondary {
  order: 2;

  @include media-breakpoint-up(md) {
    order: 1;
  }
}

.button--primary {
  order: 1;

  @include media-breakpoint-up(md) {
    order: 2;
  }
}
</style>
